import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import { makeLogger } from '../../../../logger/logger';
import type { IConversationalSearchStrategyData } from '../../types/conversational-search-srategy-data.type';
import { ConversationalSearchStrategyService } from '../../ConversationalSearchStrategyService';

const { info } = makeLogger({
  pathToCurrentFile:
    'components/strategies/services/conversational-search-service/conversational-search-srp.service.ts',
  loggersList: ['info'],
});

@Service({ id: 'conversationalSearchSrpStrategyService' })
export class CovnersationalSearchConfigurationBuilder extends StrategyBuilder<ConversationalSearchStrategyService> {
  build(
    details: IConversationalSearchStrategyData
  ): ConversationalSearchStrategyService {
      return new SRPConversationalSearchStrategyService(details);
  }
}

export class SRPConversationalSearchStrategyService extends ConversationalSearchStrategyService {
  details;
  constructor(details: IConversationalSearchStrategyData) {
      super();
      this.details = details;
  }

  private fallbackConfiguration = {
    strategyType: 'conversationalSearchSrp',
    params: {
      tabsWithConversationalSearch: [],
      isConversationalSearchActive: false,
      conversationalSearchProductsEndpoint: undefined,
      conversationalSearchMedaliaFormId: undefined,
      conversationalSearchBrandUrl: 'www.se.com'
    },
  };

  getConversationalSearchConfiguration() {
      if (!this.details?.params) {
        info('Can not load Conversational Search configuration');

        return this.fallbackConfiguration;
      }

      return this.details;
  }

  getConversationalSearchConfigurationForActiveTab(tabName: string) {
      if (
        !this.details?.params
        || !this.details?.params.tabsWithConversationalSearch.includes(tabName)
      ) {
        info(
          `Can not load Conversational Search configuration for ${tabName} tab`
        );

        return this.fallbackConfiguration;
      }

      return this.details;
  }
}
